import { MessageReader } from "../../message_handlers/message_reader.js";

export class CustomEventResponse
{
  public status: string | null = null;
  public session_id: string | null = null;
  public event_id: string | null = null;
  public duplicate = false;
  public rejected = false;
  public error: string | null = null;

  public deserialize( reader: MessageReader ): void
  {
    reader.readBody();
    this.status = reader.getBodyElement<string>( 'status' ) ?? null;
    this.session_id = reader.getBodyElement<string>( 'sessionId' ) ?? null;
    this.event_id = reader.getBodyElement<string>( 'event_id' ) ?? null;
    this.duplicate = reader.getBodyElement<boolean>( 'duplicate' ) ?? false;
    this.rejected = reader.getBodyElement<boolean>( 'rejected' ) ?? false;
    this.error = reader.getBodyElement<string>( 'error' )
      ?? reader.getBodyElement<string>( 'message' )
      ?? null;
  }
}
